export enum ICONSolutionTypes {
  ApplicationSurveyType = 'survey',
  ApplicationExcavatorType = 'excavator',
  EquipmentType= 'iCON Solutions',
}